import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Link from 'brastrap/containers/link/LinkContainer';

const BreadcrumbNav = props => (
  <nav
    className="c-breadcrumb-nav"
    role="navigation"
    aria-labelledby="breadcrumb-nav"
  >
    <h1 className="c-breadcrumb-nav__title u-hidden" id="breadcrumb-nav">
      <FormattedMessage
        id="breadcrumb-nav.title"
        defaultMessage="You are here:"
      />
    </h1>
    <ol className="c-breadcrumb-nav__items">
      {props.trail.map(breadCrumb => {
        const isCurrent = breadCrumb.last;
        const breadCrumbClass = `c-breadcrumb-nav__item ${
          isCurrent ? 'is-current' : ''
        }`;

        let content;

        if (isCurrent) {
          content = (
            <strong
              className="c-breadcrumb-nav__label"
              aria-current="page"
              aria-label={breadCrumb.label}
            >
              {breadCrumb.label}
            </strong>
          );
        } else if (breadCrumb.isDisabled) {
          content = (
            <span
              className="c-breadcrumb-nav__label c-breadcrumb-nav__label--disabled"
              aria-disabled="true"
            >
              {breadCrumb.label}
            </span>
          );
        } else {
          content = (
            <Link className="c-breadcrumb-nav__label" href={breadCrumb.url}>
              {breadCrumb.label}
            </Link>
          );
        }

        return (
          <li key={breadCrumb.url} className={breadCrumbClass}>
            {content}
          </li>
        );
      })}
    </ol>
  </nav>
);

BreadcrumbNav.propTypes = {
  trail: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      last: PropTypes.bool,
      url: PropTypes.string,
      isDisabled: PropTypes.bool,
    })
  ),
};

BreadcrumbNav.defaultProps = {
  trail: [],
};

export default BreadcrumbNav;
